import { Checkbox, ConfigProvider, Tooltip } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import copyIcon from "../../../assets/icons/add_icon_white.svg";
import alphaTraderIcon from "../../../assets/icons/AlphaTrader.svg";
import code_success_tick from "../../../assets/icons/code_success_tick.svg";
import coinPaymentIcon from "../../../assets/icons/coinpaymentsIcon.svg";
// import checkoutIcon from "../../../assets/icons/checkoutCom.svg";
import crossIcon from "../../../assets/icons/crossIconsRed.svg";
import { ReactComponent as DropdownArrow } from "../../../assets/icons/dropdwonArrow.svg";
import volumetricaIcon from "../../../assets/icons/dxFeed.svg";
import greenDot from "../../../assets/icons/greendot.svg";
import info_icon from "../../../assets/icons/info_icon.svg";
import nuvei from "../../../assets/icons/nuveis.svg";
import tradovateIcon from "../../../assets/icons/tradovate.svg";
import projectXIcon from "../../../assets/images/ProjectX.png";
import quantowerIcon from "../../../assets/images/quantower.svg";
import deepChartIcon from "../../../assets/icons/deepchart.png";
import AddressModal from "../../../components/AddressModal";
import CryptoPaymentWarningModal from "../../../components/BillingDetails/CryptoPaymentWarningModal";
import Spinner from "../../../reusableComponents/spinner/Spinner";
import { getAddresses } from "../../../utils/apis/address";
import { applyCoupon, initiatePayment } from "../../../utils/apis/payment";
import { FormatUSD } from "../../../utils/helpers/string";
import { setLastPayment } from "../../../utils/store/reducers/accountMetricsSlice";
import { returnErrors } from "../../../utils/store/reducers/Error";
import { returnMessages } from "../../../utils/store/reducers/Message";
import NacePayWidget from "../Nace/NacePayWidget";
import WealthChartsIcon from "../../../assets/icons/WealthCharts.png";

import "./style.scss"; // Use relative import for clarity

function Payments() {
  const planData = useSelector((state) => state.accountMetrics.plans);
  const { customLoading } = useSelector((state) => state.auth);
  const { id } = useParams();
  const navigate = useNavigate();
  const challengeId = Number(id); // You can set this to `null` or `undefined` if no challenge ID is provided
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [accountType, setAccountType] = useState(null);
  const [accountSizeOptions, setAccountSizeOptions] = useState([]);
  const [accountSize, setAccountSize] = useState(null);
  const [payload, setPayload] = useState({
    challenge_id: accountSize?.plans_id,
    payment_method: "nuvei",
    promo: null,
    payment_type: "purchase_challenge",
    platform: null,
    no_activation_fee: false,
  });
  const [isNoActivationFee, setIsNoActivationFee] = useState(false);

  useEffect(() => {
    setPayload((pre) => ({
      ...pre,
      challenge_id: accountSize?.plans_id,
      no_activation_fee: isNoActivationFee,
    }));
  }, [accountSize?.plans_id, isNoActivationFee]);

  useEffect(() => {
    if (!planData?.data) return;

    const accountTypeOptions = planData.data
      .filter((item) => item?.name?.toLowerCase() !== "premium plan")
      .map((item) => ({
        label: item.name,
        value: item.name,
        plans_id: item.id,
      }));

    setAccountTypeOptions(accountTypeOptions);

    // If no challengeId, select the first item as default
    const planContainingChallenge =
      planData.data.find((plan) =>
        plan.challenges.some((challenge) => challenge.id === challengeId),
      ) || planData.data[0];

    setAccountType(
      accountTypeOptions?.find(
        (item) => item.plans_id === planContainingChallenge?.id,
      ),
    );

    if (planContainingChallenge) {
      const accountSizeOptions = planContainingChallenge.challenges?.map(
        (item) => ({
          label: item.name,
          value: item.name,
          plans_id: item.id,
          amount: item.price,
          data: item,
        }),
      );
      setAccountSizeOptions(accountSizeOptions);
    }
  }, [planData, challengeId]);

  // Update accountSizeOptions when accountType changes
  useEffect(() => {
    if (accountType && planData?.data) {
      const selectedPlan = planData.data.find(
        (plan) => plan.id === accountType.plans_id,
      );

      if (selectedPlan) {
        const isPremium = accountType?.label?.toLowerCase() === "premium plan";
        setIsNoActivationFee(isPremium);

        const accountSizeOptions = selectedPlan.challenges?.map((item) => ({
          label: item.name,
          value: item.name,
          plans_id: item.id,
          amount: item.price,
          data: item,
        }));

        setAccountSizeOptions(accountSizeOptions);

        setAccountSize((prev) => {
          const existingSelection = accountSizeOptions.find(
            (item) => item.plans_id === prev?.plans_id,
          );
          return (
            existingSelection ||
            accountSizeOptions.find((item) => item.plans_id === challengeId) ||
            accountSizeOptions[0]
          );
        });

        setPayload((prev) => ({
          ...prev,
          challenge_id:
            accountSize?.plans_id ||
            challengeId ||
            accountSizeOptions[0]?.plans_id,
        }));
      }
    }
  }, [accountType, planData, challengeId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [addresses, setaddresses] = useState([]);

  const [selectedAddress, setSelectedAddress] = useState(0);
  const { idToken } = useSelector((state) => state.auth);

  const [isVisible, setIsVisible] = useState(false);
  const [isEditVisible, setIsEditVisible] = useState(false);

  const handleOverlayClick = (e) => {
    if (e.target.className === "addressModalOverlay") {
      setIsEditVisible(false);
      setIsVisible(false);
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
    getAddresses(idToken, dispatch)
      .then((response) => {
        setaddresses(response?.data);
      })
      .catch((error) => console.error("Error in Getfunded comp : ", error));
  }, [customLoading]);

  const { platForm_list } = useSelector((state) => state.accountMetrics.plans);
  const [brokers, setBrokers] = useState([]);
  useEffect(() => {
    setBrokers(platForm_list);
    // setPayload((payload) => ({
    //   ...payload,
    //   platform: platForm_list[0]?.value,
    // }));
  }, [platForm_list]);

  const paymentMethods = [
    {
      method: "Nuvei",
      value: "nuvei",
      icon: nuvei,
    },
    // {
    //   method: "Checkout",
    //   value: "checkout",
    //   icon: checkoutIcon,
    // },
    {
      method: "Coinpayments",
      value: "coinpayment",
      icon: coinPaymentIcon,
    },
  ];

  const [load, setLoad] = useState({
    isPaymentLoading: false,
    isCouponLoading: false,
  });

  const [couponCode, setCouponCode] = useState("");
  const [discountedAmount, setDiscountedAmount] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [termsMessage, setTermsMessage] = useState("");
  const [termsConditions, setTermsConditions] = useState({
    terms_conditions1: false,
    terms_conditions2: false,
    terms_conditions3: false,
    terms_conditions4: false,
    terms_conditions5: false,
    terms_conditions6: false,
  });
  const [nacePayment, setNacePayment] = useState(null);
  const [open, setOpen] = useState(false);
  const [cryptoWarningOpen, setCryptoWarningOpen] = useState(false);

  const handlePayment = async () => {
    // Check if coinpayment is selected, show warning modal first
    if (payload?.payment_method === "coinpayment") {
      setCryptoWarningOpen(true);
      return;
    }

    // For Paypal and Nuvei, open in same tab (false)
    await processPayment(false);
  };

  const handleCryptoWarningProceed = async () => {
    setCryptoWarningOpen(false);
    // For coinpayment, open in new tab (true)
    await processPayment(true);
  };

  const processPayment = async (openInNewTab = false) => {
    const allTermsAccepted = Object.keys(termsConditions).every(
      (key) => {
        if (key === "terms_conditions1" && accountType?.label?.toLowerCase() === "direct plan") return true;
        return termsConditions[key] === true;
      }
    );

    if (!allTermsAccepted) {
      return setTermsMessage("Please accept the terms and conditions.");
    }
    setTermsMessage("");
    if (payload?.platform === null) {
      dispatch(returnErrors("Please select a trading platform.", 400));
      return;
    }
    setLoad((prev) => ({ ...prev, isPaymentLoading: true }));
    try {
      const response = await initiatePayment(payload, idToken);
      if (response) {
        dispatch(setLastPayment(response?.data));
        if (response?.data?.payment_mode === "nace") {
          setNacePayment(response?.data);
          setOpen(true);
        } else if (response?.url) {
          if (openInNewTab) {
            window.open(response?.url, "_blank", "noopener,noreferrer");
          } else {
            window.location.replace(response?.url);
          }
          if (response?.data?.payment_mode?.toLowerCase() === "coinpayment") {
            navigate("/dashboard");
          }
        } else {
          dispatch(returnMessages(response?.free_coupon_message, 200));
        }
      }
    } catch (error) {
      console.error("Payment error:", error);
      dispatch(returnErrors(error?.response?.data?.detail, 400));
    } finally {
      setLoad((prev) => ({ ...prev, isPaymentLoading: false }));
    }
  };

  const handleApplyCode = async () => {
    if (!couponCode) {
      setCouponError("The coupon code should not be empty.");
      return;
    }

    setLoad((prev) => ({ ...prev, isCouponLoading: true }));
    try {
      const res = await applyCoupon(
        accountSize.plans_id,
        couponCode,
        idToken,
        "purchase_challenge",
        isNoActivationFee,
        payload.platform,
      );
      if (res) {
        setDiscountedAmount(res);
        setPayload((prev) => ({ ...prev, promo: res?.coupon_applied }));
        setCouponError("");
      }
    } catch (error) {
      console.error("Coupon application error:", error);
      dispatch(
        returnErrors(
          (error?.response?.data?.detail === "Not found."
            ? "Invalid coupon code"
            : error?.response?.data?.detail) || "Invalid coupon code",
          error?.response?.status,
        ),
      );
      setCouponError("Invalid coupon code."); // Set user-friendly error message
    } finally {
      setLoad((prev) => ({ ...prev, isCouponLoading: false }));
    }
  };

  const onChange = (e) => {
    const { checked } = e.target;
    const key = e.target.data_key; // Access the custom data_key attribute

    setTermsConditions((prev) => {
      const updatedTerms = {
        ...prev,
        [key]: checked,
      };

      const allTermsSelected = Object.values(updatedTerms).every(
        (value) => value === true,
      );

      if (allTermsSelected) {
        setTermsMessage("");
      }

      return updatedTerms;
    });
  };

  // See more Dropdown Toggle Logic
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const removedCoupon = () => {
    setCouponCode("");
    setCouponError("");
    setPayload((prev) => ({ ...prev, promo: null }));
    setDiscountedAmount(null);
  };

  const handleNavigationLinks = (url) => {
    window.open(url, "_blank");
  };

  return (
    <>
      <NacePayWidget nacePayment={nacePayment} open={open} setOpen={setOpen} />
      <CryptoPaymentWarningModal
        open={cryptoWarningOpen}
        handleProceed={handleCryptoWarningProceed}
        handleClose={() => setCryptoWarningOpen(false)}
      />
      <div className="billing-details">
        <div className="billing-details__main">
          {/* Account Type Section */}
          <section className="billing-details__section billing-details__section--account-type grid-item">
            <div className="billing-details__section-header">
              <p className="billing-details__title">Account Type</p>
              <img src={info_icon} alt="info" />
            </div>
            <div className="billing-details__options">
              {accountTypeOptions.map((item, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => {
                    setAccountType(item);
                    setDiscountedAmount(null);
                    setCouponCode("");
                    setPayload((prev) => ({ ...prev, promo: null }));
                  }}
                  className={`gray-button${accountType?.value === item?.value ? " selected" : ""
                    }`}
                >
                  {item?.label}
                </button>
              ))}
            </div>
          </section>

          {/* Account Size Section */}
          <section className="billing-details__section billing-details__section--account-size grid-item">
            <div className="billing-details__section-header">
              <p className="billing-details__title">Size</p>
              <img src={info_icon} alt="info" />
            </div>
            <div className="billing-details__options">
              {accountSizeOptions.map((amount, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => {
                    setAccountSize(amount);
                    setDiscountedAmount(null);
                    setCouponCode("");
                    setPayload((prev) => ({
                      ...prev,
                      promo: null,
                      challenge_id: amount?.plans_id,
                    }));
                  }}
                  className={`gray-button custom-width flex-center${accountSize?.label === amount?.label ? " selected" : ""
                    }`}
                >
                  ${amount?.label}
                </button>
              ))}
            </div>
          </section>

          {/* Trading Platform Section */}
          <section className="billing-details__section billing-details__section--platform grid-item">
            <div className="billing-details__section-header">
              <p className="billing-details__title">Trading Platform</p>
              <Tooltip title="Trading platform choice is final, you may not change after checkout">
                <img src={info_icon} alt="info" style={{ cursor: "pointer" }} />
              </Tooltip>
            </div>
            <div className="billing-details__options">
              {brokers
                ?.filter((broker) => broker.label !== "ProjectX/Quantower" && !broker.label.includes("Tradovate"))
                .slice()
                .sort((a, b) => {
                  const aAlpha = a.label.includes("Alpha Trader") ? 0 : 1;
                  const bAlpha = b.label.includes("Alpha Trader") ? 0 : 1;
                  return aAlpha - bAlpha;
                })
                .map((broker, index) => {
                  let icon = null;
                  if (broker.label.includes("ProjectX")) {
                    icon = projectXIcon;
                  } else if (broker.label.includes("Tradovate")) {
                    icon = tradovateIcon;
                  } else if (broker.label.includes("Quantower")) {
                    icon = quantowerIcon;
                  } else if (
                    broker.label.includes("Volumetrica") ||
                    broker.label.includes("DeepChart")
                  ) {
                    icon = deepChartIcon;
                  } else if (broker.label.includes("Alpha Trader")) {
                    icon = alphaTraderIcon;
                  }else if (broker.label.includes("WealthCharts")) {
                    icon = WealthChartsIcon;
                  }
                  return (
                    <button
                      key={index}
                      type="button"
                      onClick={() =>
                        setPayload((pre) => ({
                          ...pre,
                          platform: broker.value,
                        }))
                      }
                      className={`gray-button${
                        payload?.platform === broker.value ? " selected" : ""
                      }`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      {icon && (
                        <div className="platform-icon">
                          <img src={icon} alt={broker.label} />
                        </div>
                      )}
                      {broker?.label}
                    </button>
                  );
                })}
            </div>
          </section>

          {/* Billing Address Section */}
          <section className="billing-details__section billing-details__section--address grid-item">
            <div className="billing-details__section-header">
              <p className="billing-details__title">Billing address details</p>
            </div>
            <div className="address-scroll">
              {addresses?.map((item, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedAddress(index)}
                  className={`address-item${selectedAddress === index ? " selected-address" : ""
                    }`}
                >
                  <div className="address-details">
                    <div className="address-details__name">{item.name}</div>
                    <div className="address-details__email">
                      <img src={copyIcon} alt="" />
                      <p>{item.email}</p>
                    </div>
                    <div className="address-details__number">
                      <img src={copyIcon} alt="" />
                      <p>{item.number}</p>
                    </div>
                    <div className="address-details__address">
                      <img src={copyIcon} alt="" />
                      <span>
                        {item.apartment_no +
                          " " +
                          item.street_address +
                          " " +
                          item.city +
                          " " +
                          item.state +
                          " " +
                          item.country}
                      </span>
                    </div>
                  </div>
                  <div
                    className="address-edit"
                    onClick={() => setIsEditVisible(true)}
                  >
                    <button>
                      <p>Edit</p>
                      <img src={copyIcon} alt="" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div
              className="add-address flex-center"
              onClick={() => setIsVisible(true)}
            >
              <p>Add Address</p>
              <img src={copyIcon} alt="add" />
            </div>
          </section>
        </div>

        <div className="billing-details__side">
          {/* Payment Method Section */}
          <section className="billing-details__section billing-details__section--payment-method grid-item">
            <div className="billing-details__section-header">
              <p className="billing-details__title">Payment Method</p>
              <Tooltip title="The name on the card must exactly match the name on your Alpha Futures account.">
                <img src={info_icon} alt="info" style={{ cursor: "pointer" }} />
              </Tooltip>
            </div>
            <div className="billing-details__options">
              {paymentMethods?.map((item, index) => (
                <button
                  key={index}
                  type="button"
                  className={`gray-button${payload.payment_method === item.value ? " selected" : ""
                    }`}
                  onClick={() =>
                    setPayload((prev) => ({
                      ...prev,
                      payment_method: item.value,
                    }))
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <img src={item.icon} alt={item.method} height="100%" />
                  <p>{item.method}</p>
                </button>
              ))}
            </div>
          </section>

          {/* Challenge Summary, Coupon, Terms, and Payment Button */}
          <section className="billing-details__section billing-details__section--challenge-summary grid-item">
            <div class="accountContainer">
              <div class="accountInfo">
                <div className="checkout_info_inner">
                  <h2>Account Type</h2>
                  <p>{accountType?.label}</p>
                </div>
                <div className="checkout_info_inner">
                  <h2>Account Size</h2>
                  <p>{accountSize?.label}</p>
                </div>
                <div className="checkout_info_inner">
                  <h2>Platform</h2>
                  <p>
                    {
                      brokers?.find((item) => item.value === payload?.platform)
                        ?.label
                    }
                  </p>
                </div>
              </div>
              <div
                className={`dropdown-container ${isOpen ? "dropdownOpen" : "dropdownClose"
                  }`}
                onClick={toggleDropdown}
              >
                <button className="see_more">
                  <h2>{isOpen ? accountType?.label : <p>See More</p>}</h2>
                  <DropdownArrow
                    className={`${isOpen ? "dropdownArrow_rotate" : ""}`}
                  />
                </button>

                {isOpen ? (
                  <div
                    className={`dropdown-content ${isOpen ? "open" : ""}`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="dropdown-content_inner">
                      <div>
                        <img src={greenDot} alt="greenDot" />
                        <p>Profit Target</p>
                      </div>
                      <div>
                        <h4>{FormatUSD(accountSize?.data?.profit_target_1)}</h4>
                      </div>
                    </div>
                    <div className="dropdown-content_inner">
                      <div>
                        <img src={greenDot} alt="greenDot" />
                        <p>Starting Balance</p>
                      </div>
                      <div>
                        <h4>
                          {FormatUSD(accountSize?.data?.starting_balance)}
                        </h4>
                      </div>
                    </div>

                    <div className="dropdown-content_inner">
                      <div>
                        <img src={greenDot} alt="greenDot" />
                        <p>Min Trading Days</p>
                      </div>
                      <div>
                        <h4>{accountSize?.data?.min_trading_days} Days</h4>
                      </div>
                    </div>
                    <div className="dropdown-content_inner">
                      <div>
                        <img src={greenDot} alt="greenDot" />
                        <p>Max Loss</p>
                      </div>
                      <div>
                        <h4>{accountSize?.data?.max_loss}%</h4>
                      </div>
                    </div>

                    <div className="dropdown-content_inner">
                      <div>
                        <img src={greenDot} alt="greenDot" />
                        <p>Profit Share</p>
                      </div>
                      <div>
                        <h4>
                          {" "}
                          {accountType?.label?.toLowerCase() === "advanced plan"
                            ? ""
                            : "up to "}
                          {accountSize?.data?.profit_share ?? "-"} %
                        </h4>
                      </div>
                    </div>
                    <div className="dropdown-content_inner">
                      <div>
                        <img src={greenDot} alt="greenDot" />
                        <p>Consistency</p>
                      </div>
                      <div>
                        <h4>
                          {accountType?.label?.toLowerCase() === "zero plan"
                            ? "0"
                            :accountType?.label?.toLowerCase() === "direct plan"?"20%": "40%"}
                        </h4>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="flexColumn">
              <p className="title">Challenge</p>
              <p className="challengeTitle">
                Alpha Futures ${accountSize?.label}
              </p>
            </div>
            <div className="couponWrapper">
              <input
                placeholder="Coupon"
                type="text"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                onBlur={() => setCouponError("")}
                disabled={discountedAmount?.discount}
              />
              <div
                className={`button_container ${discountedAmount?.discount
                  ? "applied"
                  : load?.isCouponLoading && "pending"
                  }`}
              >
                <button
                  onClick={handleApplyCode}
                  disabled={load?.isCouponLoading || discountedAmount?.discount}
                >
                  {load?.isCouponLoading ? (
                    <Spinner size={20} stroke={2} />
                  ) : discountedAmount === null ? (
                    "Apply code"
                  ) : (
                    "Applied"
                  )}
                </button>
                {discountedAmount?.discount && !load?.isCouponLoading && (
                  <span onClick={removedCoupon} className="removed_coupon">
                    <img src={crossIcon} alt="crossIcon" />
                  </span>
                )}
              </div>
              {couponError && couponCode === "" && <p>{couponError}</p>}
            </div>
            {discountedAmount !== null && (
              <div
                className="code_sucess"
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <img src={code_success_tick} alt="" />
                Awesome ! Your Coupon has been Applied
              </div>
            )}
            <div className="flexSpacebetween">
              <span>Price</span>
              <span>
                $
                {isNoActivationFee
                  ? accountSize?.data?.price_2 || accountSize?.data?.price2
                  : accountSize?.amount}
              </span>
            </div>
            <div className="flexSpacebetween discountSection">
              <p>Discount</p>
              <span style={{ color: "red" }}>
                -${discountedAmount?.discount || 0}
              </span>
            </div>
            <div className="flexSpacebetween priceSection">
              <span>Total Price</span>
              <span>
                $
                {discountedAmount?.final_price ??
                  (isNoActivationFee
                    ? accountSize?.data?.price_2 || accountSize?.data?.price2
                    : accountSize?.amount)}
              </span>
            </div>
            <div className="terms_checkbox">
              <h2 style={{ marginBottom: "5px" }}>Terms Conditions</h2>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimaryHover: "none",
                  },
                }}
              >
                {accountType?.label?.toLowerCase() !== "direct plan" && (
                  <Checkbox onChange={onChange} data_key="terms_conditions1">
                    By subscribing to our service, the cardholder agrees to be
                    billed on a recurring basis, as per the selected subscription
                    plan. The subscription will automatically renew at the end of
                    each billing cycle unless the cardholder cancels the
                    subscription prior to the renewal date.
                  </Checkbox>
                )}
                <Checkbox onChange={onChange} data_key="terms_conditions2">
                  The start date of subscription is{" "}
                  {moment(Date()).format("DD-MM-YYYY")}
                </Checkbox>
                <Checkbox onChange={onChange} data_key="terms_conditions3">
                  Details of the plan. {accountSize?.label} {accountType?.label}
                </Checkbox>
                <Checkbox onChange={onChange} data_key="terms_conditions4">
                  The transaction amount (
                  {FormatUSD(
                    discountedAmount?.final_price || accountSize?.amount,
                  )}
                  ) will be deducted automatically from the cardholder's payment
                  method on the specified billing date.
                </Checkbox>
                <Checkbox onChange={onChange} data_key="terms_conditions5">
                  In some cases, the discounted amount applies only once,
                  subsequent charges will be at the full, regular rate.
                </Checkbox>
                <Checkbox onChange={onChange} data_key="terms_conditions6">
                  I consent to this subscription and I understand that all sales
                  final and no
                  <span
                    className="highlightedText"
                    style={{ color: "#4bb390", paddingLeft: "0" }}
                    onClick={() =>
                      handleNavigationLinks(
                        "https://alpha-futures.com/return-policy/",
                      )
                    }
                  >
                    {" "}
                    refunds{" "}
                  </span>
                  are to be issued.
                </Checkbox>
              </ConfigProvider>
              {termsMessage && <p style={{ color: "red" }}>{termsMessage}</p>}
            </div>

            <div className="flexCenter">
              <button
                className="standard-button width50"
                onClick={handlePayment}
              >
                {load?.isPaymentLoading ? (
                  <Spinner size={30} stroke={3} />
                ) : (
                  " Make Payment"
                )}
              </button>
            </div>
          </section>
        </div>
      </div>
      {/* Address Modal */}
      {(isEditVisible || isVisible) && (
        <div className="addressModal">
          <div className="addressModalOverlay" onClick={handleOverlayClick}>
            <AddressModal
              setIsVisible={setIsVisible}
              isVisible={isVisible}
              setIsEditVisible={setIsEditVisible}
              isEditVisible={isEditVisible}
              toEditAddress={isEditVisible ? addresses[selectedAddress] : ""}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default Payments;
